const normalizeText = (text: string): string => {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
};

export const sliceText = (value: string, length = 100) => {
  if (value === undefined || value.length < length) return value;
  return `${value.slice(0, length)}...`;
};

export const capitalize = (str?: string, allWords = false) => {
  if (!str || typeof str !== 'string') return '';

  if (allWords) {
    return str
      .toLowerCase()
      .split(' ')
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatFilter = (param: string | undefined | null, search: string | number) =>
  normalizeText(param ?? '').includes(normalizeText(String(search)));

export const getFirstName = (name: string): string => name.split(' ')[0] ?? '';

export const getUserAvatarLetters = (name: string) => {
  if (!name || typeof name !== 'string') return '';
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
};
